// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ba776d0c","453":"d2f998b2","455":"843c2253","977":"d65241b9"}[chunkId] + ".chunk.js";
};